import axiosInstance from "./axiosInstance";

// Get Instructor By ID API
export const getInstructorById = async (id) => {
  try {
    if (!id) {
      throw new Error("Instructor ID is required");
    }

    const res = await axiosInstance.get(`/instructor/${id}`);
    return res.data.data?.instructor || null;
  } catch (error) {
    throw error;
  }
};

export const updateInstructorById = async (id, updateData, files = null) => {
  try {
    const formData = new FormData();

    // ✅ Append normal fields and handle special cases
    Object.keys(updateData).forEach((key) => {
      const value = updateData[key];

      if (value === null || value === undefined) return;

      // ✅ Properly serialize arrays/objects (like awards, expertise)
      if (key === "expertise" || key === "awards") {
        formData.append(key, JSON.stringify(value));
      }
      // ✅ For arrays like deleteCertificateKeys, append each separately
      else if (key === "deleteCertificateKeys" && Array.isArray(value)) {
        value.forEach((certKey, index) => {
          formData.append(`deleteCertificateKeys[${index}]`, certKey);
        });
      }
      // ✅ Normal fields (string, number, etc.)
      else {
        formData.append(key, value);
      }
    });

    // ✅ Handle files
    if (files) {
      if (files.photo) {
        formData.append("photo", files.photo);
      }

      if (files.certificates && files.certificates.length > 0) {
        files.certificates.forEach((certificate) => {
          formData.append("certificates", certificate);
        });
      }
    }

    const res = await axiosInstance.put(`/update-instructor/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    const result = res.data;
    return result.data?.instructor || result.data;
  } catch (error) {
    throw error;
  }
};

// Create/Register Instructor API
export const createInstructor = async (instructorData, files = null) => {
  try {
    const formData = new FormData();

    Object.keys(instructorData).forEach(key => {
      if (instructorData[key] !== null && instructorData[key] !== undefined) {
        formData.append(key, instructorData[key]);
      }
    });

    if (files) {
      if (files.photo) {
        formData.append('photo', files.photo);
      }

      if (files.certificates && files.certificates.length > 0) {
        files.certificates.forEach((certificate) => {
          formData.append('certificates', certificate);
        });
      }
    }

    const res = await axiosInstance.post("/instructor/register", formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getAllInstructors = async (params = {}) => {
  try {
    const res = await axiosInstance.get("/instructors", { params });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const deleteInstructor = async (id) => {
  try {
    if (!id) {
      throw new Error("Instructor ID is required");
    }

    const res = await axiosInstance.delete(`/instructor/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const approveRejectInstructor = async (id, approvedStatus) => {
  try {
    const res = await axiosInstance.patch(`/update-instructor-approval/${id}`, {
      approved: approvedStatus
    });
    return res.data.data.instructor;
  } catch (error) {
    throw error;
  }
};


